module.exports = __webpack_public_path__ + "img/LabrynthTreasure.539bc744.png";